import Alpine from 'alpinejs';
import { collapse } from '@alpinejs/collapse';
import { resize } from '@alpinejs/resize';

// Alpine modules
import "./alpine/CardCarousel";
import "./alpine/Search";
import "./alpine/CopyImageCarousel";
import "./alpine/GalleryCarousel";
import "./alpine/GridHelper";
import "./alpine/ImageSwiper";
import "./alpine/ListingResults";
import "./alpine/SearchFilter";
import './alpine/ScrollingBanner.js';
import './alpine/ModalForm.js';
import "./alpine/MultiSelectDropdown.js";
import "./alpine/SelectDropdown.js";
import "./alpine/TestimonialCarousel.js";
import "./alpine/Timeline.js";
import "./alpine/HistorySwiper.js";
import "./alpine/TimelineIntro.js";
import "./alpine/ListingCarousel.js";
import "./alpine/GalleryLightbox.js";
import "./alpine/TeamMembers.js";
import "./alpine/FadeItemsIn.js";

import "./general/prefersReducedMotion.js";

// Components

// Global
window.Alpine = Alpine;

//Plugins
Alpine.plugin(collapse);
Alpine.plugin(resize);

// Inits
Alpine.start();

